import AdminLayout from 'layouts/Admin';
import LoginPage from 'pages/Login';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import store from 'store';

import './tailwind.css';

import 'bootstrap/dist/css/bootstrap.css';

import 'assets/scss/theme.scss';

import 'assets/demo/demo.css';

import 'perfect-scrollbar/css/perfect-scrollbar.css';

import 'assets/scss/custom.scss';

import 'react-loading-skeleton/dist/skeleton.css';

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/*" element={<AdminLayout />} />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  </Provider>,
);
